import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LicenseInfoDto } from 'src/core/models/administration/licensing/license-info.dto';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserLicensesRequestDto } from 'src/core/models/administration/licensing/add-license-request.dto';

@Injectable({
  providedIn: 'root',
})
export class LicensingService {
  constructor(private http: HttpClient) {}

  getLicenseInfo(LicenseName) {
    const url = this.getApiUrl() + '/user/license-info/' + LicenseName;

    return this.http.get(url) as Observable<LicenseInfoDto>;
  }

  activateLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/activate';

    return this.http.put(url, request) as Observable<number>;
  }

  deactivateLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/deactivate';

    return this.http.put(url, request) as Observable<number>;
  }

  convertToManualLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/convert-to-manual';

    return this.http.put(url, request) as Observable<number>;
  }

  cancelDeactivationLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/cancel-deactivation';

    return this.http.put(url, request) as Observable<number>;
  }

  excludeLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/exclude';

    return this.http.put(url, request) as Observable<number>;
  }

  includeLicense(request: UserLicensesRequestDto) {
    const url = this.getApiUrl() + '/user/include';

    return this.http.put(url, request) as Observable<number>;
  }

  private getApiUrl(): string {
    const apiBase = environment.apis.default.url;

    return apiBase + 'api/app/license';
  }
}
